// extracted by mini-css-extract-plugin
export default {"container":"SmallLoader_container__YrAtN","spinner":"SmallLoader_spinner__Y0BoB","spinner-d3wgkg":"SmallLoader_spinner-d3wgkg__xf-DX"};